import React, { useRef, useState, useMemo } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import JoditEditor from "jodit-react";

const SendConformationModal = ({
  showModal,
  hideModal,
  confirmModal,
  isSending,
  setIsSending,
}) => {
  const editor = useRef(null);
  const [htmlMessage, setHtmlMessage] = useState("");
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    []
  );
  const handleUpdate = (event) => {
    const editorContent = event.target.innerHTML;
    setHtmlMessage(editorContent);
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={hideModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="ms-auto">
            אישור שליחת הודעות
            <br />
            הוסף הערות להזמנה
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center>
            <br />
            <JoditEditor
              ref={editor}
              value={htmlMessage}
              config={config}
              onBlur={(newContent) => setHtmlMessage(newContent)}
            />

            {isSending ? (
              <>
                {" "}
                <Spinner animation="border" variant="danger" visible />
                <label>המתן עד סיום שליחת ההודעות.</label>
              </>
            ) : null}
          </center>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={hideModal}>
            ביטול
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setIsSending(true);
              confirmModal(htmlMessage);
            }}
          >
            שליחת הודעות
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SendConformationModal;
